import { render, staticRenderFns } from "./TorneoOtonoScreen.vue?vue&type=template&id=7d613e76&scoped=true"
import script from "./TorneoOtonoScreen.vue?vue&type=script&lang=js"
export * from "./TorneoOtonoScreen.vue?vue&type=script&lang=js"
import style0 from "./TorneoOtonoScreen.vue?vue&type=style&index=0&id=7d613e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d613e76",
  null
  
)

export default component.exports